import React, { PropsWithChildren, useMemo } from 'react'
import { Modal, ScrollDim, useModalAnimation } from '@yanolja-org/ya-com-modal'
import useEventHooks from '~/app/components/common/useEventHooks'

/**
 * ScrollDimModal component
 * author: soojin.oh
 * $description$
 */

// type definitions
type ScrollDimModalProps = {
  isOpened: boolean
  targetId: string
  isDisabledTouch?: boolean
  className?: string
}

// styled components

// ScrollDimModal component
const ScrollDimModal = function ({
  isOpened,
  targetId,
  isDisabledTouch,
  children,
  className,
}: PropsWithChildren<ScrollDimModalProps>) {
  const { onAnimationEnd, isDetached } = useModalAnimation({ isOpened, targetId })
  const { stopAndPrevent } = useEventHooks()
  const onAnimationEndAndStop = useMemo(() => stopAndPrevent(onAnimationEnd), [onAnimationEnd])
  const touchEvent = e => {
    if (!isDisabledTouch) {
      e.stopPropagation()
    } else {
      /**
       * 고속버스 주문 상세 > 승차권 > 수동검표 시
       * 터치 이벤트를 감지하지 못해 패턴 동작이 정상적이지 않음.
       * props 로 disabled 를 전달받아 이벤트 전파 차단을 하지 않음.
       */
      return
    }
  }
  return (
    <Modal isOpened={isOpened} isDetached={isDetached}>
      <ScrollDim
        id={targetId}
        className={`${className} ${isOpened ? 'open' : 'close'}`}
        onTouchStart={touchEvent}
        onTouchMove={touchEvent}
        onTouchEnd={touchEvent}
        onAnimationEnd={onAnimationEndAndStop}
      >
        {children}
      </ScrollDim>
    </Modal>
  )
}

export default ScrollDimModal
